(function () {
    const svgTag =
        '<svg xmlns="http://www.w3.org/2000/svg" width="19.43" height="11.428" viewBox="0 0 19.43 11.428"><path class="a" d="M35.43,35.712a.962.962,0,0,0-.232-.589l-4.572-4.857a.983.983,0,0,0-1.25-.071.893.893,0,0,0,.009,1.25L32.6,34.855H16.857a.857.857,0,1,0,0,1.714H32.6L29.385,39.98a.944.944,0,0,0-.009,1.25.97.97,0,0,0,1.25-.071L35.2,36.3a.828.828,0,0,0,.232-.589Z" transform="translate(-16 -30)"/></svg>';
    const teaserLinks = document.querySelectorAll('.diu-neos-component-teaser__link');

    if (teaserLinks.length > 0) {
        teaserLinks.forEach(function (teaserLink) {
            const paragraph = teaserLink.querySelector('.diu-neos-component-teaser__text-paragraph');

            if (paragraph) {
                const lastChild = paragraph.lastChild;

                if (lastChild.innerHTML) {
                    lastChild.innerHTML = lastChild.innerHTML + svgTag;
                } else {
                    paragraph.innerHTML = paragraph.innerHTML + svgTag;
                }
            }
        });
    }
})();
